export const getTimeOnPageInSeconds = (openedAt: number | null): number | undefined => {
  if (openedAt === null) {
    return undefined
  }

  return Math.round((Date.now() - openedAt) / 1000)
}
